import { render, staticRenderFns } from "./important2.vue?vue&type=template&id=c56a9f58&"
import script from "./important2.vue?vue&type=script&lang=ts&"
export * from "./important2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports